import React, { useEffect, useContext, useCallback } from 'react';
import { FLEET_TAB } from 'modules/fleet/events';

import { ShipperFilter } from 'modules/filters';

import GatekeepingFiltersContext from 'modules/gatekeeping/filters/context';
import { useSelector } from 'react-redux';
import { constants, getClientConfig } from 'redux/modules/client-config/selectors';

const filterWidth = (width) => ({ style: { minWidth: width, maxWidth: width } });

const GateKeepingFilters = () => {
  const { filters, setFilters } = useContext(GatekeepingFiltersContext);

  const handleShipperChange = useCallback(
    (value) => {
      setFilters((oldFilters) => ({
        ...oldFilters,
        shipper: value,
      }));
    },
    [setFilters]
  );
  const FILTERS = useSelector((state) => getClientConfig(state, constants.FILTERS));

  useEffect(() => {
    if (FILTERS[constants.FLEET_SHIPPER]) FLEET_TAB.APPLY_FILTER(filters);
  }, [filters, FILTERS]);
  if (!FILTERS[constants.FLEET_SHIPPER]) return <></>;

  return (
    <>
      <div className="filter" {...filterWidth('240px')}>
        <ShipperFilter value={filters?.shipper} onChange={handleShipperChange} />
      </div>
    </>
  );
};

export default GateKeepingFilters;
